import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ActionType,
  VerifyResetPasswordTokenData,
  VerifyResetPasswordTokenResponse,
} from "models/verifyResetPasswordToken";
import { httpStatus } from "configs/httpStatus";
import { verifyResetToken } from "services/verifyResetToken";
import {
  handleSuccessAction,
  handleErrorAction,
} from "./verifyResetPasswordTokenActions";

function* verifyResetPasswordTokenSaga({
  payload,
}: {
  payload: VerifyResetPasswordTokenData;
}) {
  try {
    const response: VerifyResetPasswordTokenResponse = yield call(
      verifyResetToken,
      payload
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccessAction(response.message));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onVerifyResetPasswordTokenSagaWatcher() {
  yield takeLatest(
    ActionType.VERIFY_RESET_TOKEN as any,
    verifyResetPasswordTokenSaga
  );
}

export default [fork(onVerifyResetPasswordTokenSagaWatcher)];
